import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';



class ShowAnnotationsToggle extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visibility: true
		}
	}

	componentDidMount() {
		this.componentWillUpdate(this.props);
	}

	componentWillUpdate(nextProps) {
		const valInStore = nextProps.annotationVisibility.visible
		if (valInStore !== this.state.visibility) {
			this.setState({visibility: valInStore});
		}
	}

	changeVisibility = (value) => {
    const { store } = this.context;
    store.dispatch({
      type: "SET_ANNOTATION_VISIBILITY",
      payload: {
        visible: value,
      }
    });
  }

	render() {
		return(
	  	<span onClick={()=>{this.changeVisibility(!this.state.visibility)}}>
		  	<span>{this.state.visibility ? "Hide":"Reveal"}&nbsp;annotations</span>
	  	</span>
		)
	}
}
ShowAnnotationsToggle.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const annotationVisibility = state.annotationVisibility;
  return { annotationVisibility };
}

export default connect(mapStateToProps, {})(ShowAnnotationsToggle);


// WEBPACK FOOTER //
// ./src/components/interactive/votePref/ShowAnnotationsToggle.js